import React from "react";
import PropTypes from "prop-types";
import Icon from "@material-ui/core/Icon";
import DialogActions from "@material-ui/core/DialogActions";

function DialogFooter({ children, note, noteIcon }) {
  return (
    <DialogActions style={{ padding: 0, margin: 0 }}>
      <div style={{
        width: "100%",
        display: "flex",
        justifyContent: note ? "space-between" : "flex-end",
        alignItems: "center",
        padding: "16px 24px",
        background: "#ffffff",
        borderTop: "1px solid #edf0f3",
        gap: "12px"
      }}>
        {note && (
          <span style={{ fontSize: "12px", color: "#94a3b8", display: "flex", alignItems: "center", gap: "6px", fontWeight: 500 }}>
            {noteIcon && <Icon style={{ fontSize: "15px", color: "#cbd5e1" }}>{noteIcon}</Icon>}
            {note}
          </span>
        )}
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          {children}
        </div>
      </div>
    </DialogActions>
  );
}

DialogFooter.propTypes = {
  children: PropTypes.node.isRequired,
  note: PropTypes.string,
  noteIcon: PropTypes.string
};

export default DialogFooter;
